import { styled } from '@mui/material'
import { colors } from '@theme/variables'

export const ProfileDelegateEventsContainer = styled('div')<{ $showBorder?: boolean }>`
  ${props =>
    props.$showBorder
      ? `border-left: 1px solid ${colors.bodyText};
    padding-left: 10px;`
      : ''}
`

export const ProfileHeaderDate = styled('div')`
  display: flex;
  gap: 10px;
  align-items: center;
`
